import FiMenu from '@meronex/icons/fi/FiMenu';
import icon from './StyledIcon';
export default icon(FiMenu, {shapeRendering: 'crispedges'});
